import './main.css'
import '../App.css'
import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faCircleCheck, faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import MessageModal from './messageModal';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { changeNum, changeUnits } from './common/function';
import { BeatLoader } from "react-spinners";
import { changeAlramModal, changeGold, checkDuplicateLogins, checkMySkin } from '../store';
import { useTranslation } from "react-i18next";

function Character() {
    const { t } = useTranslation();
    let dispatch = useDispatch()
    let JWT = useSelector((state) => { return state.JWT.value })
    let mySkin = useSelector((state) => { return state.mySkin })

    const [message, setMessage] = useState("");
    const [choose, setChoose] = useState([])
    const [unlock, setUnlock] = useState(false)
    const [owned, setOwned] = useState([])
    const [skinList, setSkinList] = useState([])
    const [reload, setReload] = useState(false)

    useEffect(() => {
        setChoose(mySkin)
    }, [])

    useEffect(() => {
        CharacterSkin()
    }, [reload])

    const CharacterSkin = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/character', {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setOwned(tmp?.data?.owned ?? [])
                setSkinList(tmp?.data?.skin ?? [])
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const ChangeSkin = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/character/use' + `?skinId=${choose.id}`, {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                dispatch(checkMySkin(choose))
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const sortedSkinList = skinList.slice().sort((a, b) => {
        // 조건 2: choose의 id와 같으면 가장 상단으로 정렬
        if (a.id === mySkin.id) return -1;
        if (b.id === mySkin.id) return 1;

        // 조건 1: 배열 owned에 포함되어 있으면 앞으로 정렬
        const aOwned = owned.includes(a.id);
        const bOwned = owned.includes(b.id);

        if (aOwned && !bOwned) return -1;
        if (!aOwned && bOwned) return 1;

        return 0; // 나머지 경우는 그대로 유지
    });

    const [imageLoaded, setImageLoaded] = useState(false);

    return (
        <div className='main'>
            <MessageModal message={message} />
            {unlock && (<CharacterUnlock choose={choose} setUnlock={setUnlock} setReload={setReload} setMessage={setMessage} ChangeSkin={ChangeSkin} />)}
            <div className='character'>
                <div className='character-left'>
                    <div className='character-left-top'>
                        <img
                            src={`${process.env.REACT_APP_API}${choose.skin_img}`}
                            alt="캐릭터"
                            style={{ display: imageLoaded ? 'block' : 'none' }}
                            onLoad={() => setImageLoaded(true)}
                            onError={() => setImageLoaded(false)}
                        />
                    </div>
                    <div className='character-left-bottom'>
                        <div style={{ fontSize: "13px", fontWeight: "500", marginBottom: '20px' }}>{choose?.skin_name ?? ""}</div>
                        {/* <div style={{ fontSize: "12px", marginBottom: '30px' }}>Your league's {choose?.skin_name ?? ""} skin</div> */}
                        {
                            owned.includes(choose.id)
                                ?
                                mySkin.id == choose.id
                                    ?
                                    <>
                                        <div style={{ fontSize: "15px", marginBottom: '10px', fontWeight: '500', color: '#65a967', height: "25px" }}>{t('character_0')}</div>
                                        <div className='charcter-left-btn'>{t('character_1')}</div>
                                    </>
                                    :
                                    <>
                                        <div style={{ fontSize: "15px", marginBottom: '10px', fontWeight: '500', color: '#65a967', height: "25px" }}>{t('character_0')}</div>
                                        <div className='charcter-left-btn' style={{ background: "#5b60f6" }} onClick={() => ChangeSkin()}>{t('character_1')}</div>
                                    </>
                                :
                                <>
                                    <div style={{ fontSize: "15px", marginBottom: '10px', fontWeight: '500', display: 'flex', alignItems: 'center', justifyContent: 'center', height: "25px" }}>
                                        <img src="/newImg/icon_main_diamond.png" className="img_diamond" alt="Diamond" style={{ pointerEvents: "none", width: "18px", marginRight: "5px" }} />
                                        <div className='fontNumber' style={{ display: 'flex', alignItems: "center" }}>
                                            <span>{changeUnits(choose?.skin_value ?? 0)}</span>
                                        </div>
                                    </div>
                                    <div className='charcter-left-btn' style={{ background: "#5b60f6" }} onClick={() => setUnlock(true)}>
                                        {t('character_2')} <FontAwesomeIcon icon={faLock} style={{ marginLeft: "5px" }} />
                                    </div>
                                </>
                        }
                    </div>
                </div>
                <div className='character-right'>
                    <div className="character-grid">
                        {
                            sortedSkinList.map(function (a, i) {
                                return (
                                    <div key={i} className={`character-card ${choose.skin_name === a.skin_name ? "active" : ""}`} onClick={() => setChoose(a)}>
                                        <img src={`${process.env.REACT_APP_API}${a.skin_img}`} className="character-image" />
                                        <div className="character-name">{a.skin_name}</div>
                                        {
                                            owned.includes(a.id)
                                                ?
                                                mySkin.id == a.id
                                                    ?
                                                    <div className="lock-check">
                                                        <img src='/newImg/check.png' style={{ width: '20px' }} />
                                                        {/* <FontAwesomeIcon icon={faCircleCheck} /> */}
                                                    </div>
                                                    :
                                                    ""
                                                :
                                                <div className="lock-icon"><FontAwesomeIcon icon={faLock} /></div>
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

function CharacterUnlock({ choose, setUnlock, setReload, setMessage, ChangeSkin }) {
    const { t } = useTranslation();
    let JWT = useSelector((state) => { return state.JWT.value })
    let gold = useSelector((state) => { return state.gold.value })
    let dispatch = useDispatch()
    const [buyBtn, setBuyBtn] = useState(false)

    const CharacterBuy = async () => {
        setBuyBtn(true)
        await axios.post(process.env.REACT_APP_API + '/api/character', {
            skinId: choose.id
        }, {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setTimeout(() => {
                    dispatch(changeGold(gold - choose?.skin_value))
                    setMessage({ "code": 0, "msg": t('message_5') })
                    dispatch(changeAlramModal())
                    ChangeSkin()

                    setBuyBtn(false)
                    setUnlock(false)
                    setReload(e => !e)
                }, 1000)
            }
            else {
                setTimeout(() => {
                    setMessage({ "code": 1, "msg": t('message_5') })
                    dispatch(changeAlramModal())
                    setBuyBtn(false)
                }, 1000)
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    return (
        <div className='modal'>
            <div className='modal-background' onClick={() => setUnlock(false)}></div>
            <div className='airdrop-modal'>
                <FontAwesomeIcon icon={faCircleXmark} className='modal-x' onClick={() => setUnlock(false)} />
                <div style={{ fontSize: '18px', fontWeight: "500", marginBottom: "15px" }}>{t('character_3')} {choose?.skin_name ?? ""} {t('character_3_1')}</div>
                <div style={{ marginBottom: "15px", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img src="/newImg/icon_main_diamond.png" className="img_diamond" alt="Diamond" style={{ pointerEvents: "none", width: "18px", marginRight: "3px" }} />
                    <div className='fontNumber' style={{ display: 'flex', alignItems: "center" }}>
                        <span>{changeUnits(choose?.skin_value ?? 0)}</span>
                    </div>
                </div>
                <div className='modal-airdrop-btn' style={{ marginBottom: "10px", background: "#5b60f6" }} onClick={() => { !buyBtn && CharacterBuy() }}>
                    {
                        buyBtn
                            ?
                            <BeatLoader size={13} color="#003577" />
                            :
                            t('character_4')
                    }
                </div>
                <div className='modal-airdrop-btn' style={{ marginBottom: "10px", background: "#272a2e", border: '1px solid #37393e' }}
                    onClick={() => { !buyBtn && setUnlock(false) }}>{t('character_5')}</div>
            </div>
        </div>
    )
}

export default Character;